import * as React from 'react';
import {useState} from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Hidden, IconButton, Typography} from '@material-ui/core';
import {createStyles,Theme,makeStyles} from '@material-ui/core/styles';
import { primaryBlue, primaryGray } from 'src/components/sub-components/colors/colors';
import { Step1 } from './steps/Step1';
import { Step2 } from './steps/Step2';
import { TextBar } from 'src/components/sub-components/TextBar';
import { Step3 } from './steps/Step3';
import { Step4 } from './steps/Step4';

export function AddNewFirmWare(props) {
    const classes = useStyles()

    const [step,setStep]=useState(0)

    const [steps,setSteps]=useState([
        {
            text:"Basic Details",
            activate:true
        },
        {
            text:"Remote Configuration",
            activate:false
        },
        {
            text:"Add Technology Flow Chart",
            activate:false
        },
        {
            text:"Select Testing Device",
            activate:false
    }])

    const [addParameter,setAddParameter]=useState(false)
    const openAddParameter=()=>{
        setAddParameter(true)
    }
    const closeAddParameter=()=>{
        setAddParameter(false)
    }
    
    const increaseStep=()=>{
        if(step===3){
            //submit should be here
            return
        }
        else{
            setStep(step+1)
            steps.map((s,i)=>{
                if(i<=step+1){
                    s.activate=true
                }
                else{
                    s.activate=false
                }
            })
            setSteps(steps)
        }
    }
    const decreaseStep=()=>{
        if(step===0){
            props.onClose()
            return
        }
        else{
            setStep(step-1)
            steps.map((s,i)=>{
                if(i<=step-1){
                    s.activate=true
                }
                else{
                    s.activate=false
                }
            })
            setSteps(steps)
        }
    }

    return (
        <Dialog open={props.open}>
            <Grid container>
                <Grid item xs={10} md={10}>
                    <DialogTitle>Add {addParameter?"Parameter":"Firmware"}</DialogTitle>
                </Grid>
                <Grid item xs={2} md={2} style={{textAlign:"right"}}>
                    <IconButton onClick={()=>{
                        props.onClose() }}>
                        <CloseIcon/>
                    </IconButton>
                </Grid>
            </Grid>
            
            <Divider/>
            {
                addParameter?
// ***** This is add new parameter input filed set ***** //
                <>
                <DialogContent>
                    <Grid container style={{textAlign:"center", marginTop:"20px"}}>
                        <Grid item xs={6} md={6} style={{textAlign:"left",paddingBottom:"20px"}}>
                            <Typography className={classes.label}>Enter Parameter</Typography>
                            <TextBar error={{error:false}}/>
                        </Grid>
                        <Grid item xs={6} md={6} style={{textAlign:"left",paddingBottom:"20px",paddingLeft:"20px"}}>
                            <Typography className={classes.label}>Select Id</Typography>
                            <TextBar error={{error:false}}/>
                        </Grid>
                        <Grid item xs={6} md={6} style={{textAlign:"left",paddingBottom:"20px"}}>
                            <Typography className={classes.label}>Enter Input Type</Typography>
                            <TextBar error={{error:false}}/>
                        </Grid>
                        <Grid item xs={6} md={6} style={{textAlign:"left",paddingBottom:"20px",paddingLeft:"20px"}}>
                            <Typography className={classes.label}>Default</Typography>
                            <TextBar error={{error:false}}/>
                        </Grid>
                        <Grid item xs={6} md={6} style={{textAlign:"left",paddingBottom:"20px"}}>
                            <Typography className={classes.label}>Enter Format</Typography>
                            <TextBar error={{error:false}} />
                        </Grid>
                        <Grid item xs={6} md={6} style={{textAlign:"left",paddingBottom:"20px",paddingLeft:"20px"}}>
                            <Typography className={classes.label}>Join parameter</Typography>
                            <TextBar error={{error:false}}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{width:"100%"}}>
                    <Button variant='contained' className={classes.cancel} onClick={closeAddParameter}>
                        Cancel
                    </Button>
                    <Button variant='contained' className={classes.add}>
                        Save
                    </Button>
                </DialogActions>
                </>

                :
// ***** This is add normal pop-up steps ***** //
                <>
                <DialogContent>
                    <Grid container style={{textAlign:"center", marginTop:"20px"}}>
                        {
                            steps.map((step, index)=>(
                                <Hidden key={index}>
                                    {index===0 &&  <Grid item xs={1} md={1}></Grid>}
                                    <Grid item xs={1} md={1}>
                                        <Circle number={index+1} active={step.activate} step={step}/>
                                    </Grid>
                                    {
                                        index!==3 &&  
                                        <Grid item xs={2} md={2} style={{width:"100px"}}>
                                            <hr style={{marginTop:"20px",opacity:steps[index+1].activate?"1":"0.12"}} color={steps[index+1].activate?primaryBlue:"rgba(112, 112, 112, .12)"}/>
                                        </Grid>
                                    }
                                </Hidden>
                            ))
                        }
                        {
                            steps.map((step,index)=>(
                                <Grid item xs={3} md={3} key={index}>
                                    <Typography style={{fontSize:'12px',paddingTop:"10px",color:step.activate?primaryBlue:primaryGray}}>{step.text}</Typography>
                                </Grid>
                            ))
                        }
                        <Grid item xs={12} md={12}>
                            {step===0 && <Step1/>}
                            {step===1 && <Step2 open={()=>openAddParameter()}/>}
                            {step===2 && <Step3/>}
                            {step===3 && <Step4/>}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{width:"100%"}}>
                    <Button onClick={decreaseStep} variant='contained' className={classes.cancel}>
                    {step===1 || step===2 || step===3?"Back":"Cancel"}
                    </Button>
                    <Button onClick={increaseStep} variant='contained' className={classes.add}>
                        {step===0 || step===1 || step===2?"Next":"Submit"}
                    </Button>
                </DialogActions>
                </>
            }
            
        </Dialog>
    )
}

export const Circle=(props)=>{
    return(
        <div>
            <div style={{
                    borderRadius:"50%",
                    width:"40px",
                    height:"40px",
                    backgroundColor:"white",
                    border:props.active?"2px solid #2A7CED":"0.25px solid #8F8F8F",
                    textAlign:"center",
                    paddingTop:"10px",
                    boxShadow:"0px 4px 8px #0000001F"}}>
                <h5 style={{color:props.active?primaryBlue:primaryGray}}>{props.number}</h5>
            </div>
        </div>
    )
}


const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    add:{
        backgroundColor:primaryBlue,
        color:"white",
        marginBottom:"10px",
        marginRight:"10px",
        width:"20%",
        boxShadow:"none",
        "&:hover":{
            boxShadow:"none",
        }
    },
    cancel:{
        backgroundColor:"white",
        color:primaryGray,
        marginBottom:"10px",
        marginRight:"10px",
        width:"20%",
        boxShadow:"none",
        "&:hover":{
            boxShadow:"none",
        }
    },
    label:{
        fontSize:"15px",
        color:primaryGray,
        paddingBottom:"5px"
    }
  }),
);

export const CloseIcon=()=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#666D73"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
    )
}